import { render, staticRenderFns } from "./cabinetUpdate.vue?vue&type=template&id=08e36f60&scoped=true&"
import script from "./cabinetUpdate.vue?vue&type=script&lang=ts&"
export * from "./cabinetUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./cabinetUpdate.vue?vue&type=style&index=0&id=08e36f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e36f60",
  null
  
)

export default component.exports